import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import "./errorPage.css";
import { Button } from '@mui/material';
import {useNavigate} from "react-router-dom";

const ErrorPage = () => {
    const navigate =  useNavigate()
  return (
    <div id='error-page'>
        <div id="error-page-text">
        <span> <SentimentDissatisfiedIcon style={{fontSize:"100px"}} /> </span>
        <div>
            <p><span style={{fontWeight:"bold",fontSize:"30px",color:"red"}}>OOPS!</span> something went wrong</p>
            <p className='error-text'>The link you have entered is broken or might be changed</p>
            <p className='error-text'>Click the button below to redirect to the site</p>
            <div className='error-text' style={{textAlign:"center"}}> <Button variant="contained" onClick={()=>navigate('/')} >Redirect</Button> </div>
            
        </div>
        </div>
    </div>
  )
}

export default ErrorPage